import {Injectable} from '@angular/core';
import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class FormValidationService {
  static phoneValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = typeof control.value === 'string' ? control.value.trim() : control.value;
      if (!value) return null;

      const hasCorrectPattern = /^\+[1-9]\d{1,14}$/.test(value);
      return hasCorrectPattern ? null : {phoneNumber: true};
    };
  }

  passwordValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = typeof control.value === 'string' ? control.value.trim() : control.value;
      if (!value) return null;

      const hasUppercase = /[A-Z]/.test(value);
      const hasLowercase = /[a-z]/.test(value);
      const hasNumber = /\d/.test(value);
      const hasSpecial = /[^A-Za-z0-9]/.test(value);
      const isValid = hasUppercase && hasLowercase && hasNumber && hasSpecial;

      return isValid ? null : {password: true};
    };
  }

  numbersOnlyValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = typeof control.value === 'string' ? control.value.trim() : control.value;
      if (!value) return null;

      const isValidNumber = /^\d+$/.test(value);
      return isValidNumber ? null : {numbersOnly: true};
    };
  }

  emailValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = typeof control.value === 'string' ? control.value.trim() : control.value;
      if (!value) return null;

      // Regex that requires a TLD (e.g. .com, .de) of at least 2 characters
      // and ensures local part and domain part start with alphanumeric characters
      const emailPattern = /^[a-zA-Z0-9][a-zA-Z0-9._%+-]*@[a-zA-Z0-9][a-zA-Z0-9.-]*\.[a-zA-Z]{2,}$/;
      const isValid = emailPattern.test(value);

      return isValid ? null : {email: true};
    };
  }

  passwordMatchValidator(): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const password = formGroup.get('password');
      const confirmPassword = formGroup.get('passwordRepeat');

      if (!password || !confirmPassword) return null;

      if (password.value !== confirmPassword.value) {
        confirmPassword.setErrors({passwordMismatch: true});
        return {passwordMismatch: true};
      } else {
        confirmPassword.setErrors(null);
        return null;
      }
    };
  }

  dateRangeValidator(startDateField: string, endDateField: string): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const startDate = formGroup.get(startDateField);
      const endDate = formGroup.get(endDateField);

      if (!startDate || !endDate) return null;

      const startValue = startDate.value;
      const endValue = endDate.value;

      if (!startValue || !endValue) {
        endDate.setErrors(null);
        return null;
      }

      if (endValue < startValue) {
        endDate.setErrors({dateRange: true});
        return {dateRange: true};
      }

      endDate.setErrors(null);
      return null;
    };
  }
}
